import React from 'react';
import {
  Button,
  Center,
  Heading,
  Image,
  Modal,
  ModalBody,
  ModalContent,
  ModalOverlay,
  Text,
  VStack,
} from '@chakra-ui/react';
import { useNavigate } from 'react-router-dom';
import Warning from '../../../images/cartaoAtualizacao.svg';

/**
 * Modal bloqueante exibido quando o cliente é assinante, maior de idade
 * e ainda não possui nenhum cartão cadastrado no sistema Vindi.
 *
 * Não possui botão de fechar/dispensar — o usuário só sai ao cadastrar o cartão.
 */
const ModalCadastrarCartaoVindi = ({ disclosure }) => {
  const navigate = useNavigate();

  const handleCadastrar = () => {
    disclosure.onClose();
    navigate('/perfil/pagamento/cadastro-cartao', { state: { voltar: true } });
  };

  return (
    <Modal
      isOpen={disclosure.isOpen}
      isCentered
      size="xs"
      closeOnOverlayClick={false}
      closeOnEsc={false}
    >
      <ModalOverlay bg="blackAlpha.600" />
      <ModalContent borderRadius="1em" mx={4}>
        <ModalBody pb={6} pt={5}>
          <Center mb={3}>
            <Image src={Warning} h="3.5em" />
          </Center>

          <Heading textAlign="center" color="#333333" size="md" mb={3}>
            Cadastre seu cartão
          </Heading>

          <VStack bg="#F5F5F5" p={4} borderRadius="0.8em" mb={5}>
            <Text color="#555555" textAlign="center" fontSize="sm" lineHeight="1.5">
              Para continuar utilizando o app, você precisa cadastrar um cartão de
              crédito no novo sistema de pagamento DeoVita.
            </Text>
          </VStack>

          <Button
            bg="#5AB2AE"
            color="white"
            w="100%"
            borderRadius="0.8em"
            fontWeight="bold"
            _hover={{ bg: '#4A9E9A' }}
            onClick={handleCadastrar}
          >
            Cadastrar cartão agora
          </Button>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

export default ModalCadastrarCartaoVindi;
